import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

export default function createListFormatter(locale: Bcp47Locale) {
  return (list: string[], options?: Intl.ListFormatOptions) =>
    new Intl.ListFormat(locale, options).format(list)
}
